import { createPostEndpoint } from '@sonar-software/sonar-http';
import { InitiativeFile } from '@types';

export type PostInitiativeFileRequest = {
	file: File;
	initiativeId: number;
	name?: string;
};

export const postInitiativeFile = createPostEndpoint<PostInitiativeFileRequest, InitiativeFile>(
	({ initiativeId, name }) => `/api/v3/initiatives/${initiativeId}/files?name=${encodeURIComponent(name ?? '')}`
);
